<script setup lang="ts">
import type { Schemas } from "#shopware";

const props = defineProps<{
  product: Schemas["Product"];
  quantity: number;
  hidePrice?: boolean;
}>();

const { quantity } = toRefs(props);

const emits = defineEmits<{
  (
    e: "select",
    product: {
      id: string | undefined;
      quantity: number;
      cover: Schemas["Media"] | undefined;
      productNumber: string;
      name: string;
      unitPrice: number | undefined;
      type: string;
    }
  ): void;
  (e: "remove", id: string): void;
}>();

const { product } = toRefs(props);

const { unitPrice } = useProductPrice(product);

const selected = ref(false);

const selectProduct = () => {
  const isProductSelected = selected.value;
  const productId = product.value.id;
  const payload = {
    id: productId,
    quantity: quantity.value,
    cover: product.value?.cover?.media,
    name: product.value?.translated?.name,
    unitPrice: unitPrice.value,
    productNumber: product.value?.productNumber,
    type: "product",
  };

  if (isProductSelected) {
    emits("select", payload);
  } else {
    emits("remove", productId);
  }
};

onUnmounted(() => {
  selected.value = false;
});
</script>
<template>
  <div class="flex items-center gap-x-2.5">
    <div class="relative">
      <input
        type="checkbox"
        v-model="selected"
        class="absolute w-full h-full opacity-0 cursor-pointer [&:checked+label]:text-sm [&:checked+label]:bg-skin-theme"
        @change="selectProduct"
      />
      <label
        class="block w-5 h-5 border border-skin-light rounded text-0 text-center py-0.5 text-skin-white"
      >
        <i class="fa-solid fa-check"></i>
      </label>
    </div>
    <NuxtImg
      format="webp"
      loading="lazy"
      :src="product?.cover?.media?.url"
      :alt="product?.translated?.name"
      :width="product?.cover?.media?.metaData?.width"
      :height="product?.cover?.media?.metaData?.height"
      class="object-contain h-full w-full"
    />
    <h4>
      <SharedPrice
        v-if="!hidePrice"
        :value="unitPrice * quantity"
        class="font-bold text-base"
      />
    </h4>
  </div>
</template>
